let flkty;

function initFlickity() {
  if (flkty) {
    flkty.destroy();
  }
  const options =
    window.innerWidth < 768
      ? { initialIndex: 0, groupCells: 1 }
      : { initialIndex: 1, groupCells: 3 };
  flkty = new Flickity(".carousel", options);
}

function temporize() {
  const currentDate = new Date();
  const images = document.querySelectorAll("img");
  const baseDesktop = document.getElementById("desktop-base");
  const baseMobile = document.getElementById("mobile-base");
  console.log(baseMobile);

  images.forEach((image) => {
    const match = image.id.match(
      /image-\d+-(\d{2}\/\d{2}\/\d{4})-(\d{2}\/\d{2}\/\d{4})/
    );
    if (match) {
      const [, startDateStr, endDateStr] = match;
      const [day, month, year] = startDateStr.split("/").map(Number);
      const startDate = new Date(year, month - 1, day); // Month is 0-indexed
      startDate.setHours(0, 0, 0, 0);

      const [endDay, endMonth, endYear] = endDateStr.split("/").map(Number);
      const endDate = new Date(endYear, endMonth - 1, endDay);
      endDate.setHours(23, 59, 59, 999);

      if (currentDate >= startDate && currentDate <= endDate) {
        image.classList.remove("hidden");
        baseDesktop.classList.add("hidden");
        baseMobile.classList.add("hidden");
      } else {
        image.classList.add("hidden");
        baseDesktop.classList.remove("hidden");
        baseMobile.classList.remove("hidden");
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", temporize);
initFlickity();
window.addEventListener("resize", initFlickity);
